import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";

import { useRoles } from "commons/src/helpers/RoleHelpers";

import { Forbidden } from "./Forbidden";

export function PrivateRoute({ component, requiresRole, ...rest }) {
    const isAuthorised = useRoles(requiresRole);
    window.scrollTo(0, 0);

    if (!isAuthorised) {
        return <Forbidden />;
    }

    return <Route {...rest} component={component} />;
}

PrivateRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    requiresRole: PropTypes.string
};
